function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { ArrowRight } from '../../visuals';
import { Body, CallToAction, Heading, Label } from '../../atoms';
import ReactConfigContext from '../../ReactConfigContext';
export default function LittleCard(param) {
    var image = param.image, label = param.label, title = param.title, description = param.description, action = param.action, className = param.className;
    var _useContext = useContext(ReactConfigContext), ImageComponent = _useContext.config.ImageComponent;
    return /*#__PURE__*/ React.createElement("article", {
        className: twMerge('p-5 grid gap-7 bg-bg-subtle rounded-xl grid-cols-1 sm:p-6 sm:grid-cols-[9.5rem_1fr]', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "rounded-md overflow-hidden safari-fix-transform"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        className: twMerge(image.className, 'w-full h-full object-cover object-center')
    }))), /*#__PURE__*/ React.createElement("div", null, !!label && /*#__PURE__*/ React.createElement(Label, {
        className: "mb-3 sm:mb-5"
    }, label), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4"
    }, title), !!description && /*#__PURE__*/ React.createElement(Body, {
        className: "mt-3 prose"
    }, description)), !!action && /*#__PURE__*/ React.createElement("div", {
        className: "mt-5"
    }, /*#__PURE__*/ React.createElement(CallToAction, _object_spread_props(_object_spread({}, action), {
        buttonType: "icon-after",
        icon: /*#__PURE__*/ React.createElement(ArrowRight, null)
    })))));
}

//# sourceMappingURL=LittleCard.js.map